<div class="terminal-overlay">
    <div class="terminal-overlay__wrapper">
        <priva-content-template>
            <priva-content-header [hasOffset]="false" [areaBottomTmp]="contentHeaderBottom">
                <priva-header
                    iconClass="fas {{ icon() }}"
                    [title]="title()"
                    [subtitle]="subtitle()"
                    [iconOffset]="false"
                    category="Blue"
                    size="sm"
                    data-test="terminal-header-title"
                >
                    @if (!isPackingActivity() || !isContainerMeasurement()) {
                        <button
                            data-start
                            priva-button
                            type="button"
                            importance="Tertiary"
                            iconState="Only"
                            iconClass="fas fa-arrow-left"
                            class="page-overview-trigger"
                            (click)="close()"
                            data-test="terminal-header-back-button"
                        ></button>
                    }
                </priva-header>
                @if (isPackingActivity() && isContainerMeasurement()) {
                    <button
                        class="terminal-overlay__finish"
                        data-test="btn-finish-manual-mode"
                        priva-button
                        (click)="finish()"
                    >
                        {{ 'PACKING.FINISH.BUTTON' | translate }}
                    </button>
                }
                <ng-template #contentHeaderBottom>
                    <ng-content select="[header]" />
                </ng-template>
            </priva-content-header>
            <priva-content-section maxWidth="lg" [isCentered]="true" class="content-section">
                <ng-content />
            </priva-content-section>
        </priva-content-template>
        <footer class="terminal-overlay__footer">
            <ng-content select="[data-footer]" />
        </footer>
    </div>
</div>
